import ViewExhibit from "./ViewExhibit";

export default ViewExhibit